export default __webpack_public_path__ + "static/media/timeline-05.5a0af2ad.png";